var _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar_2_",
    "data-name": "calendar (2)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M65.188,162.875a1.25,1.25,0,0,0,0,2.5h1.875a1.25,1.25,0,0,0,0-2.5h-.625v-.77l1.657-1.1h1.687a1.563,1.563,0,1,0,0-.625H68.095l-1.657-1.1v-.77H68a.313.313,0,0,0,.313-.312v-1.875A.313.313,0,0,0,68,156H64.25a.313.313,0,0,0-.312.313v1.875a.313.313,0,0,0,.313.313h1.563v.77l-1.657,1.1h-1.03v-.937a.313.313,0,0,0-.312-.312h-2.5a.313.313,0,0,0-.312.313v2.5a.313.313,0,0,0,.313.313h2.5a.313.313,0,0,0,.313-.312V161h1.03l1.657,1.1v.77Zm-.625-6.25h3.125v1.25H64.563Zm-2.062,5H60.625V159.75H62.5Zm8.813-1.875a.938.938,0,1,1-.937.938A.939.939,0,0,1,71.313,159.75Zm-5.187.063,1.312.874-1.312.874-1.312-.874Zm1.563,4.312a.626.626,0,0,1-.625.625H65.188a.625.625,0,0,1,0-1.25h1.875A.626.626,0,0,1,67.688,164.125Z",
    transform: "translate(-58.125 -151.625)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M15.688,16.625H13.313v-.312a.313.313,0,0,0-.625,0v.313H10.813v-.312a.313.313,0,0,0-.625,0v.313H8.313v-.312a.313.313,0,0,0-.625,0v.313H5.813v-.312a.313.313,0,0,0-.625,0v.313H3.313v-.312a.313.313,0,0,0-.625,0v.313H.313A.313.313,0,0,0,0,16.938v13.75A.313.313,0,0,0,.313,31H6.594a.313.313,0,0,0,0-.625H.625V19.75h14.75V30.375H9.406a.313.313,0,0,0,0,.625h6.281A.313.313,0,0,0,16,30.688V16.938A.313.313,0,0,0,15.688,16.625ZM.625,19.125V17.25H2.688v.938a.313.313,0,0,0,.625,0V17.25H5.188v.938a.313.313,0,0,0,.625,0V17.25H7.688v.938a.313.313,0,0,0,.625,0V17.25h1.875v.938a.313.313,0,0,0,.625,0V17.25h1.875v.938a.313.313,0,0,0,.625,0V17.25h2.063v1.875Z",
    transform: "translate(0 -16)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 0.313,
    cy: 0.313,
    r: 0.313,
    transform: "translate(7.688 14.375)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.6a66d8b4.svg";
export { ForwardRef as ReactComponent };